import * as Yup from 'yup';

import { StrategyType } from '@ndvr/portfolio-api';

import { assetAllocationSchema } from '../shared-schemas';
import { createTotalWeightTest, createUniqueNameTest } from '../shared-utils';

export const createFormSchema = (existingStrategyNames: string[] = [], currentStrategyName?: string) =>
    Yup.object({
        strategyName: Yup.string()
            .required('Strategy name is required')
            .trim()
            .min(1, 'Strategy name cannot be empty')
            .max(100, 'Strategy name cannot exceed 100 characters')
            .test(
                'unique-name',
                'A strategy with this name already exists',
                createUniqueNameTest(existingStrategyNames, currentStrategyName),
            ),
        strategyType: Yup.string()
            .oneOf([StrategyType.PERSONAL, StrategyType.SHARED])
            .required('Strategy type is required'),
        assetAllocations: Yup.array()
            .of(assetAllocationSchema)
            .default([])
            .min(1, 'At least one asset allocation is required')
            .test('total-weight', 'Total weight must equal 100%', createTotalWeightTest()),
    });

export type FormValues = Yup.InferType<ReturnType<typeof createFormSchema>>;
